import { formatPrice } from './formatPrice';

export const formatPriceRange = (start?: number, end?: number) => {
  let startPrice;
  let endPrice;

  if (!start) {
    return { startPrice, endPrice };
  }

  if (end) {
    endPrice = `до ${formatPrice(end)} ₽`;
  }

  startPrice = `от ${formatPrice(start)} `;
  if (!end) {
    startPrice += '₽';
  }

  return { startPrice, endPrice };
};
